/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatedApiResponse } from '../../models/created-api-response';

export interface CreateFinancialAdvisorAsync$Params {
      body?: {
'Name'?: string;
'LastName'?: string;
'Photo'?: Blob;
'Email'?: string;
'PhoneNumber'?: string;
'Commission'?: number;
'SupervisorCommission'?: number;
'OfficeId'?: number;
'SupervisorId'?: number;
'Marketing'?: number;
'IsActive'?: boolean;
}
}

export function createFinancialAdvisorAsync(http: HttpClient, rootUrl: string, params?: CreateFinancialAdvisorAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatedApiResponse>> {
  const rb = new RequestBuilder(rootUrl, createFinancialAdvisorAsync.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatedApiResponse>;
    })
  );
}

createFinancialAdvisorAsync.PATH = '/api/financial-advisor';
